import useCheckoutContext from "./store"
import classNames from "classnames"

function StepHeading({
  isActiveStep,
  stepIndex,
  title = "Title",
  description,
  descriptionType
}) {
  const { steps } = useCheckoutContext()
  const isDescriptionVisible = isActiveStep && description

  return (
    <div className={["flex-col"].join(" ")}>
      {steps.length > 1 && (
        <div className="text-sm font-bold">
          Steg {parseInt(stepIndex) + 1} av {steps.length}
        </div>
      )}

      <p
        className={classNames("text-lg font-bold lg:text-3xl", {
          "mb-4": isActiveStep && !description
        })}>
        {title}
      </p>

      {isDescriptionVisible &&
        (descriptionType === undefined || descriptionType == "normal") && (
          <div
            className="my-4 text-lg"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

      {isDescriptionVisible && descriptionType == "green" && (
        <div
          id="stepDescription"
          className="p-4 my-4 rounded-sm bg-summer-green-50"
          dangerouslySetInnerHTML={{ __html: description }}></div>
      )}
    </div>
  )
}

export default StepHeading
